<script setup lang="ts">
import { cx } from '../ui'

withDefaults(
  defineProps<{
    align?: 'left' | 'right' | 'center'
    class?: string
  }>(),
  { align: 'left' },
)
</script>

<template>
  <th
    scope="col"
    :class="
      cx(
        'px-4 py-2.5 text-left text-[11px] font-semibold tracking-wide whitespace-nowrap text-dim',
        align === 'right' && 'text-right',
        align === 'center' && 'text-center',
        $props.class,
      )
    "
  >
    <slot />
  </th>
</template>
